import { CODE, CONTEXT } from 'domains/product-attribute/constants'


const SellerInboundCurationService = {

  /**
   * Build payload
   * TODO: add payload documentation
   * @param {object} values - Formik's values
   * @param {array} attributes - Product Attributes
   * @param {object} defaultValues - Default value for the payload
   */
  buildPayload: (values, attributes, defaultValues = {}) => {
    // Filtering attributes with details context, name, or code
    const detailsAtt = attributes.filter((attribute) => attribute.context === CONTEXT.DETAILS ||
      attribute.code === CODE.NAME ||
      attribute.code === CODE.PRICE
    )

    // Filtering attributes with measurement context only
    const measurementAtt = attributes.filter((attribute) => attribute.context === CONTEXT.MEASUREMENT)

    const payload = {
      ...defaultValues,
      product: {
        ...payloadBuilder.create(detailsAtt, values, { category: values.category }),
        dimension: payloadBuilder.create(measurementAtt, values, { size: values.size })
      }
    }

    return payload
  }
}

/**
 * Helper object to build payload for Product Attribute
 */
const payloadBuilder = {

  /**
   * Create payload
   * @param {array} attributes - Selected attributes
   * @param {object} values - Formik's values
   * @param {object} initialValues - Initial Values
   */
  create: (attributes, values, initialValues = {}) => {
    let product_attributes = initialValues

    attributes.forEach((attribute) => {
      product_attributes[attribute.code] = values[attribute.code]
    })

    return product_attributes
  }
}

export default SellerInboundCurationService
